import BackendConnector from './backendConnector';

export default class TasksHttpService {
    static getTaskData(taskId) {
        return BackendConnector.get(`system/task/${taskId}`);
    }
}
